import { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { debounce } from 'debounce';
import RadioInput from './RadioInput';

type SearchBoxProps = {
  setParentSearchStr: (str: string) => void;
  searchMode?: string;
  setSearchMode?: (mode: string) => void;
};

export default function SearchBox({
  setParentSearchStr,
  searchMode,
  setSearchMode,
}: SearchBoxProps) {
  const [searchStr, setSearchStr] = useState('');

  function handleSearchStrChange(e) {
    setSearchStr(e.target.value);
  }

  function handleSearchModeChange(e) {
    if (setSearchMode) {
      setSearchMode(e.target.value);
    }
  }

  const debouncedSetParentSearchStr = debounce(
    (str) => setParentSearchStr(str),
    200
  );

  useEffect(
    () => debouncedSetParentSearchStr(searchStr),
    [debouncedSetParentSearchStr, searchStr]
  );

  return (
    <div className="flex flex-col mb-3">
      <div className="relative flex items-center mb-2">
        <input
          type="text"
          className="form-input py-2 px-5 rounded-half w-full border-2 border-gray-300 focus:ring-0 focus-visible:ring-0 placeholder-gray-300 text-gray-800 focus:border-gray-400 focus-visible:border-gray-400"
          placeholder={
            searchMode === 'categories'
              ? 'Search for categories'
              : 'Search for variables'
          }
          value={searchStr}
          onChange={handleSearchStrChange}
        />
        {searchStr !== '' && (
          <div className="absolute right-5 text-lg inset-y-0 flex items-center">
            <button
              type="button"
              onClick={() => {
                setSearchStr('');
                setParentSearchStr('');
              }}
            >
              <IoMdClose className="stroke-current fill-current text-gray-600 hover:text-gray-800" />
            </button>
          </div>
        )}
      </div>
      {setSearchMode && (
        <div className="flex gap-4 text-xs font-semibold text-gray-600 uppercase px-2">
          <label className="flex items-center gap-2 cursor-pointer hover:text-gray-800">
            <RadioInput
              value="variables"
              checked={searchMode === 'variables'}
              onChange={handleSearchModeChange}
            />
            <span>Variables</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer hover:text-gray-800">
            <RadioInput
              value="categories"
              checked={searchMode === 'categories'}
              onChange={handleSearchModeChange}
            />
            <span>Categories</span>
          </label>
        </div>
      )}
    </div>
  );
}
